import { useState } from "react";
import { Link } from "react-router-dom";
import { Layers } from "lucide-react";
import { formatKr } from "../../lib/format";

export default function StatsVariants({ data }) {
  const [mode, setMode] = useState("offer");
  if (!data.has_variant_offers) {
    return (
      <section className="panel" data-testid="stats-variants">
        <h2>Bedst sælgende varianter</h2>
        <div className="st-empty small" data-testid="stats-variants-empty">
          <Layers size={20} aria-hidden="true" />
          <p>Ingen tilbud med varianter i perioden. Tilføj fx farver eller størrelser på et tilbud, så kan du se her, hvilke der sælger bedst.</p>
        </div>
      </section>
    );
  }
  const rows = mode === "offer" ? data.top : data.by_name;
  return (
    <section className="panel" data-testid="stats-variants">
      <div className="st-panel-head">
        <h2>Bedst sælgende varianter</h2>
        <div className="st-seg mini" role="tablist">
          <button type="button" className={mode === "offer" ? "on" : ""} onClick={() => setMode("offer")} data-testid="stats-variants-mode-offer">Pr. tilbud</button>
          <button type="button" className={mode === "name" ? "on" : ""} onClick={() => setMode("name")} data-testid="stats-variants-mode-name">Samlet pr. navn</button>
        </div>
      </div>
      <ol className="st-vlist" data-testid={`stats-variants-list-${mode}`}>
        {rows.map((v, i) => (
          <li key={mode + i} data-testid={`stats-variant-row-${i}`}>
            <span className="st-vrank">{i + 1}</span>
            <span className="st-vname">
              <b>{v.name}</b>
              {mode === "offer"
                ? <Link to={`/offers/${v.offer_id}`}>{v.offer_title}</Link>
                : <small>{v.offers} {v.offers === 1 ? "tilbud" : "tilbud"}</small>}
            </span>
            <span className="st-vnum"><b>{v.sold}</b><small>solgt</small></span>
            <span className="st-vnum"><b>{v.picked}</b><small>udleveret</small></span>
            <span className="st-vnum"><b>{formatKr(v.revenue)}</b><small>omsætning</small></span>
            {mode === "offer" && (
              <span className="st-vshare" title={`${v.share} % af tilbuddets salg`}>
                <span className="st-bar"><i style={{ width: `${v.share}%` }} /></span>
                <small>{v.share} % af tilbud</small>
              </span>
            )}
          </li>
        ))}
      </ol>
    </section>
  );
}
